/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1AssociatedcompanyCompaniesDropdown200,
  GetApiV1AssociatedcompanyCompaniesDropdown401,
  GetApiV1AssociatedcompanyCompaniesDropdown500,
  GetApiV1AssociatedcompanyCompaniesDropdownQueryResponse,
} from "../../types/associatedCompanySharedController/GetApiV1AssociatedcompanyCompaniesDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1AssociatedcompanyCompaniesDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1AssociatedcompanyCompaniesDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1AssociatedcompanyCompaniesDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyCompaniesDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1AssociatedcompanyCompaniesDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1AssociatedcompanyCompaniesDropdown500>;

export const getApiV1AssociatedcompanyCompaniesDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1AssociatedcompanyCompaniesDropdown200Schema,
  ) as unknown as ToZod<GetApiV1AssociatedcompanyCompaniesDropdownQueryResponse>;
